import React, { forwardRef } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import GlobalFooterCertificates from "./GlobalFooterCertificates";
import GlobalFooterCertificateImage from "./GlobalFooterCertificateImage";
import GlobalFooterSocial from "./GlobalFooterSocial";
import GlobalFooterSocialMedia from "./GlobalFooterSocialMedia";
import GlobalFooterImpressum from "./GlobalFooterImpressum";
import GlobalFooterLink from "./GlobalFooterLink";

import styles from "./GlobalFooter.scss";

export const GlobalFooter = forwardRef(({ children, customClass }, ref) => (
  <div ref={ref} className={cx(styles.container, customClass)}>
    <div className={styles.inner_container}>{children}</div>
  </div>
));

GlobalFooter.Certificates = GlobalFooterCertificates;
GlobalFooter.CertificateImage = GlobalFooterCertificateImage;
GlobalFooter.Social = GlobalFooterSocial;
GlobalFooter.SocialMedia = GlobalFooterSocialMedia;
GlobalFooter.Impressum = GlobalFooterImpressum;
GlobalFooter.Link = GlobalFooterLink;

GlobalFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  customClass: PropTypes.string,
};

GlobalFooter.defaultProps = {
  customClass: undefined,
};

GlobalFooter.displayName = "GlobalFooter";

export default GlobalFooter;
